// @core/api/endpoints/task/create_view.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateViewRequest,
  ViewResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Create view
 * Creates a saved view with predefined filters and sorting. Views can be personal or shared with the team.
 */
export async function CreateView(
  data: CreateViewRequest,
  options?: RequestOptions
): Promise<ViewResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/task-views`;
  const requestOptions = options;
  return client.post<ViewResponse>(requestPath, data, requestOptions);
}
